module.exports = "https://retros.devl.appslatam.com/images/avion_card_OLA.svg?1a2da242a530b3970c6751131eadec23";